import { render, staticRenderFns } from "./PublishErrorModal.vue?vue&type=template&id=2f250642&scoped=true&"
import script from "./PublishErrorModal.vue?vue&type=script&lang=js&"
export * from "./PublishErrorModal.vue?vue&type=script&lang=js&"
import style0 from "./PublishErrorModal.vue?vue&type=style&index=0&id=2f250642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f250642",
  null
  
)

export default component.exports